/* eslint-disable import/prefer-default-export */
/* eslint-disable no-bitwise */
export const toOrdinal = (int) => `${int}${[undefined, 'st', 'nd', 'rd'][int % 100 >> 3 ^ 1 && int % 10] || 'th'}`;

export const humanizeDuration = (duration) => {
  const units = ['years', 'months', 'days', 'hours', 'minutes', 'seconds'];
  const valueObj = _.pick(duration.shiftTo(...units).values, _.identity);

  let unit;
  for (let i = 0; i <= units.length - 1; i += 1) {
    if (valueObj[units[i]] && Math.abs(valueObj[units[i]]) >= 1) {
      unit = units[i];
      break;
    }
  }

  const roundedDuration = Math.abs(Math.round(duration.as(unit)));
  const indefiniteArticle = unit === 'hours' ? 'an' : 'a';

  return (
    `${roundedDuration === 1 ? indefiniteArticle : roundedDuration} ${roundedDuration === 1 ? unit.slice(0, -1) : unit}`
  );
};

export const numberWithDelimiter = (number, { delimiter = ',' } = {}) => {
  if (number === undefined) return '';

  const parts = number.toString().split('.');
  const left = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, (a) => a + delimiter);
  return [left, parts[1]].join('.').replace(/\.$/, '');
};
